export const extractServerMessage = (message: string): string => {
  try {
    const parsed = JSON.parse(message);
    if (parsed && typeof parsed.message === "string") {
      return parsed.message;
    }
  } catch {
    // Not JSON — fall through to the raw message.
  }

  return message;
};
